(function () {
  var COLOR_ALIASES = {
    cobalt: ["cobalt", "coblat"],
    "sparrow acid-dye": ["sparrow"],
    "black acid-dye": ["black", "acid"],
    "royal navy": ["navy"]
  };

  function updateBadge(card) {
    var badge = card.querySelector('[data-bestseller-badge]');
    if (!badge) return;

    var figure = card.querySelector('[data-product-image]');
    var img = figure ? figure.querySelector('img') : null;

    if (!img) {
      badge.style.display = 'none';
      return;
    }

    var src = (img.currentSrc || img.getAttribute('src') || '').toLowerCase();
    var colors = (badge.getAttribute('data-bestseller-colors') || '')
      .split('|')
      .filter(Boolean);

    var isMatch = colors.some(function (color) {
      var key = color.toLowerCase();
      var aliases = COLOR_ALIASES[key] || [key.split(/[\s-]/)[0]];
      return aliases.some(function (a) { return src.indexOf(a) !== -1; });
    });

    badge.style.display = isMatch ? 'block' : 'none';
  }

  function watchCard(card) {
    updateBadge(card);

    new MutationObserver(function () {
      updateBadge(card);
    }).observe(card, { attributes: true, childList: true, subtree: true });

    // Redundant safety net: swatch hover/click directly triggers a re-check
    card.querySelectorAll('[data-swatch-button], [data-swatch-variant]').forEach(function (swatch) {
      swatch.addEventListener('mouseenter', function () { updateBadge(card); });
      swatch.addEventListener('click', function () { updateBadge(card); });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-product-block]').forEach(watchCard);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-product-block]')) watchCard(node);
        if (node.querySelectorAll) node.querySelectorAll('[data-product-block]').forEach(watchCard);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();